import { sendDataEvent } from "//gunner.com/cdn/shop/t/565/assets/data-capture_send-event.js?v=5624375915771028481695906007";
import { cookies } from "//gunner.com/cdn/shop/t/565/assets/f_cookies.js?v=90746454558969621681683109459";

const blogModal = document.querySelector('.blog-modal-background');

// showBlogModal()
const showBlogModal = () => {
  if (cookies.get('blog-modal-seen')) {
    return;
  }

  cookies.set('blog-modal-seen', true, 30);

  // Show the blogModal.
  blogModal.style.zIndex = '99999999';
  blogModal.classList.add('visible');
  document.querySelector('body').classList.add('no-scrolling');
  document.querySelector('body').classList.add('modal-opened');

  setTimeout(() => {
    const eventData = {
      event_name: 'modal_viewed',
      event_element_id: '7wMCrsQ9trtmwzxYkjSduQB1yzgMEwCx'
    };
    sendDataEvent(eventData);
  });
};

// hideBlogModal()
const hideBlogModal = () => {

  // Hide the blogModal.
  document.querySelector('body').classList.remove('no-scrolling');
  document.querySelector('body').classList.remove('modal-opened');

  setTimeout(function () {
    blogModal.classList.remove('visible');
    setTimeout(() => blogModal.style.zIndex = null, 100);
  }, 100);
};

// handleBlogModalClickOutside()
// If the blogModal is currently visible (the click is not within the blogModal || is the blogModal close button || is the blogModal open button) - hide the blogModal.
const handleBlogModalClickOutside = (e) => {
  if (blogModal && blogModal.classList.contains('visible') && ((!blogModal.querySelector('.blog-modal-content').contains(e.target) && !e.target.classList.contains('blog-modal-open') && !e.target.closest('.blog-modal-open')) || e.target === blogModal.querySelector('.blog-modal-close'))) {
    if (!e.target.closest('.needsclick')) {
      hideBlogModal();

      const eventData = {
        event_name: 'click_outside_close',
        event_element_id: '2j5hgj7f8pUUj849ejovuyHxEUf55tmU'
      };
      sendDataEvent(eventData);
    }
  }
}

document.addEventListener('click', (e) => handleBlogModalClickOutside(e));

setTimeout(() => showBlogModal(), 3000);

export { showBlogModal as default };